/* eslint import/prefer-default-export: 0 */

import * as t from './action_types';

export const editingImage = () => ({
  type: t.COMPANY_IMAGE_EDITING,
});

export const editingCancelImage = () => ({
  type: t.COMPANY_IMAGE_CANCEL_EDITING,
});

export const savingImage = () => ({
  type: t.COMPANY_IMAGE_SAVING,
});

export const savingImageSuccess = () => ({
  type: t.COMPANY_IMAGE_SUCCESS,
});

export const savingImageFailure = message => ({
  message,
  type: t.COMPANY_IMAGE_FAILURE,
});

export const unloadSavingImage = () => ({
  type: t.UNLOAD_COMPANY_IMAGE,
});
